export default function EcpContentSwitch(EcpNavigationTab, value) {
    var content = {}
    switch (EcpNavigationTab) {
        case "abstract":
            content = {step: "abstract", nb_sentences_abstract: value}
            break
        case "summary":
            content = {step: "summary", nb_sentences_summary: value}
            break
        case "keypoints":
            content = {step: "keypoints", nb_keypoints: value}
            break
        case "verbatims":
            content = {step: "verbatims", nb_verbatims: value}
            break
        case "glossary":
            content = {step: "glossary", nb_terms: value}
            break
        default:
            break
    }
    return content
}